(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;
  const toggle = document.querySelector('.motion-toggle');
  let paused = reduced.matches;
  let frame = 0;
  let last = 0;
  let particles = [];
  const canvas = document.querySelector('.holiday-particles');
  const ctx = canvas?.getContext('2d');
  const clamp = v => Math.max(0, Math.min(1, v));
  const resize = () => {
    if (!canvas || !ctx) return;
    const scale = Math.min(devicePixelRatio || 1, 1.5);
    canvas.width = innerWidth * scale;
    canvas.height = innerHeight * scale;
    ctx.setTransform(scale, 0, 0, scale, 0, 0);
    particles = Array.from({ length: innerWidth < 760 ? 28 : 60 }, () => ({ x: Math.random() * innerWidth, y: Math.random() * innerHeight, size: .6 + Math.random() * 2.3, speed: 8 + Math.random() * 23, drift: Math.random() * Math.PI * 2, gold: Math.random() > .62 }));
  };
  const animate = time => {
    if (paused || document.hidden || reduced.matches) { frame = 0; return; }
    if (time - last >= 32) {
      const delta = Math.min((time - last) / 1000, .06);
      last = time;
      if (ctx) {
        ctx.clearRect(0, 0, innerWidth, innerHeight);
        particles.forEach(p => {
          p.y += p.speed * delta;
          p.x += Math.sin(time / 2200 + p.drift) * delta * 10;
          if (p.y > innerHeight + 5) { p.y = -5; p.x = Math.random() * innerWidth; }
          ctx.beginPath(); ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
          ctx.fillStyle = p.gold ? 'rgba(251,215,133,.7)' : 'rgba(255,240,222,.55)';
          ctx.fill();
        });
      }
    }
    frame = requestAnimationFrame(animate);
  };
  const start = () => { if (!frame && !paused && !reduced.matches && !document.hidden) { last = performance.now(); frame = requestAnimationFrame(animate); } };
  const updateToggle = () => {
    root.classList.toggle('effects-paused', paused);
    if (toggle) { toggle.setAttribute('aria-pressed', String(paused)); toggle.querySelector('[data-motion-label]').textContent = paused ? toggle.dataset.play : toggle.dataset.pause; }
  };
  toggle?.addEventListener('click', () => { paused = !paused; updateToggle(); if (paused) { cancelAnimationFrame(frame); frame = 0; ctx?.clearRect(0, 0, innerWidth, innerHeight); } else start(); updateScene(); });
  let scrollFrame = 0;
  const updateScene = () => {
    scrollFrame = 0;
    document.querySelectorAll('[data-melt-journey]').forEach(scene => {
      const rect = scene.getBoundingClientRect();
      const active = rect.top < innerHeight && rect.bottom > 0;
      scene.classList.toggle('in-view', active);
      if (!active) return;
      const progress = reduced.matches || paused ? 1 : clamp(-rect.top / Math.max(1, scene.offsetHeight - innerHeight));
      scene.style.setProperty('--progress', progress.toFixed(3));
      scene.style.setProperty('--fire', clamp((progress - .12) / .22).toFixed(3));
      scene.style.setProperty('--melt', clamp((progress - .4) / .48).toFixed(3));
      const step = progress < .25 ? 0 : progress < .6 ? 1 : 2;
      scene.querySelectorAll('[data-ritual-step]').forEach((item, i) => item.classList.toggle('active', reduced.matches || i === step));
    });
  };
  const onScroll = () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScene); };
  const initPairings = scope => scope.querySelectorAll('.pairing-panel').forEach(panel => {
    if (panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    panel.querySelectorAll('[data-pair]').forEach(button => button.addEventListener('click', () => {
      panel.querySelectorAll('[data-pair]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      const image = panel.querySelector('.pairing-picture img'); if (image && button.dataset.pairImage) { image.src = button.dataset.pairImage; image.removeAttribute('srcset'); image.alt = button.textContent + ' chocolate dipping inspiration'; }
      panel.querySelectorAll('[data-pair-panel]').forEach(p => { p.hidden = p.dataset.pairPanel !== button.dataset.pair; });
    }));
  });
  root.classList.add('motion-ready');
  resize(); initPairings(document); updateToggle(); updateScene(); start();
  addEventListener('resize', () => { resize(); onScroll(); }, { passive: true });
  addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('visibilitychange', start);
  reduced.addEventListener('change', () => { paused = reduced.matches; updateToggle(); updateScene(); start(); });
  document.addEventListener('shopify:section:load', e => { initPairings(e.target); updateScene(); });
})();
